import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { API } from '@constants/api';
import { SETTING_KEYS } from '@constants/settings';
import { AuthModel, NO_PERMISSIONS, UserInfo } from '@models/auth.model';
import { ResponseAPI } from '@models/response';
import { NgxPermissionsService } from 'ngx-permissions';
import { BehaviorSubject, lastValueFrom } from 'rxjs';
import { getStorage } from '../utils/helper';
import { BaseService } from './base.service';
import { MatDialog } from '@angular/material/dialog';
import { N22Component } from '@modules/user/pages/n22/n22.component';

@Injectable({
  providedIn: 'root',
})
export class PermissionsService extends BaseService {
  private _userInfo = new BehaviorSubject<UserInfo | Record<string, never>>({});
  constructor(private permissions: NgxPermissionsService, private router: Router, private dialog: MatDialog) {
    super();
  }

  refreshToken(refreshToken: any) {
    return this.httpClient.post<ResponseAPI<AuthModel>>(API.auth.refresh, { refreshToken });
  }

  logout() {
    localStorage.clear();
    this.permissions.flushPermissions();
    this.router.navigate(['auth', 'login']);
    this._userInfo.next({});
  }

  get userInfo() {
    return this._userInfo.asObservable();
  }

  async loadPermission() {
    const isAccessAuth = location.pathname.includes('auth');
    const home = '/market';
    if (!getStorage(SETTING_KEYS.jwt)) {
      this.permissions.loadPermissions([NO_PERMISSIONS]);
      if (!isAccessAuth) {
        location.href = home;
      }
      return NO_PERMISSIONS;
    }
    try {
      const response = await lastValueFrom(this.httpClient.get<ResponseAPI<UserInfo>>(API.auth.me));
      if (response.data.role === 'ID_USER' || response.data.role === 'NUTRI_SHOP') {
        location.href = '/market';
        return NO_PERMISSIONS;
      }
      this._userInfo.next(response.data);
      this.permissions.loadPermissions([response.data.role]);
      if (!response.data.region) {
        this.dialog.open(N22Component, {
          width: '30rem',
        });
      }
      return response.data.role;
    } catch (error) {
      console.log(error);
      localStorage.clear();
    }
    if (!isAccessAuth) {
      location.href = home;
    }
    this.permissions.loadPermissions([NO_PERMISSIONS]);
    return NO_PERMISSIONS;
  }
}
